import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Task } from '@ml/tasks/types/classes';
import { OrderLocation } from '@ml/orders/types/classes';
import * as _ from 'lodash';
import { TaskLocation } from '@ml/tasks/types/classes/task-location.class';
import { TaskLocationStatus } from '@ml/tasks/types/enums/task-location-status.enum';
import { User } from '@ml/core/types/classes';
import { UserRole } from '@ml/core/types/enums';
import { Service } from '@ml/services/types/service';
import { Order } from '@ml/orders/types/order';
import { Location } from '@ml/shared/types/location';

@Component({
  selector: 'ml-order-location-status',
  template: `
    <div fxLayout="row" fxLayoutAlign="start center">
      <div *ngFor="let task of parsedTasks; let l = last">
        <div fxLayout="row" fxLayoutAlign="start center">
          <div
            (click)="onSelectField(task)"
            class="circle"
            [matTooltip]="task.name"
            [ngClass]="getCircleClasses(task)"
          >
            <b>{{
              locationViewMode === 'task'
                ? task.position + 1
                : task.servicePosition + 1
            }}</b>
          </div>
          <div *ngIf="!l" class="line" [ngClass]="getStatusClass(task)"></div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./order-location-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderLocationStatusComponent implements OnInit {
  @Input() user: User;
  @Input() currentTask: Task;
  @Input() tasks: Task[];
  @Input() orderLocation: OrderLocation;

  @Output() selectLocation = new EventEmitter<TaskLocation>();

  locations: TaskLocation[];
  locationViewMode = 'task';

  constructor() {}

  ngOnInit() {}

  onSelectField(task: Task) {
    if (this.canSelectTask(task)) {
      const taskLocation = this.getLocation(task);
      this.selectLocation.emit(taskLocation);
    }
  }

  get parsedTasks(): Task[] {
    if (this.tasks.length === 0) {
      return [];
    }
    const locationViewMode = (this.tasks[0].order as Order).locationViewMode;
    this.locationViewMode = locationViewMode;
    if (locationViewMode === 'task') {
      return this.tasks;
    } else if (locationViewMode === 'service') {
      const services = [];
      return this.tasks
        .filter(task => {
          if (task.service === null) {
            return true;
          }
          if (services.includes((task.service as Service).id)) {
            return false;
          }
          services.push((task.service as Service).id);
          return true;
        })
        .sort((a: Task, b: Task) => {
          return a.servicePosition > b.servicePosition ? 1 : -1;
        });
    }

    return this.tasks;
  }

  getCircleClasses(task: Task) {
    let classes = `${this.getCurrentTaskClass(task)} ${this.getStatusClass(
      task
    )}`;
    if (this.canSelectTask(task)) {
      classes += ' cursor-pointer';
    }
    return classes;
  }

  getCurrentTaskClass(task: Task) {
    if (this.currentTask && this.currentTask.id === task.id) {
      return 'current-task';
    }
  }

  private canSelectTask(task: Task) {
    if (this.user && this.user.role === UserRole.ADMIN) {
      return true;
    }
    if (this.currentTask && this.currentTask.id === task.id) {
      return true;
    }

    return (
      this.currentTask &&
      (this.currentTask.service as Service).id === task.service
    );
  }

  getStatusClass(task: Task) {
    const taskLocation = this.getLocation(task);
    switch (taskLocation.status) {
      case TaskLocationStatus.NOT_STARTED:
        return 'not-started';
      case TaskLocationStatus.IN_PROGRESS:
        return 'in-progress';
      case TaskLocationStatus.STOPPED:
        return 'stopped';
    }
  }

  private getLocation(task: Task): TaskLocation {
    const locations = task.locations as TaskLocation[];
    return locations.find(location => {
      if (typeof location.orderLocation === 'number') {
        return location.orderLocation === this.orderLocation.id;
      }
      return location.orderLocation.id === this.orderLocation.id;
    });
  }
}
